import {cx} from "@emotion/css";
import * as React from "react";

import "./rects.scss";

import {cs}                    from "@Common/react/chain-services";
import {consumeContext}        from "@Common/react/context";
import {fragments}             from "@Common/react/fragments";
import {keyCombo}              from "@Common/react/key-combo";
import {keyed}                 from "@Common/react/keyed";
import {Load}                  from "@Common/react/load";
import {UseState}              from "@Common/react/use-state";
import {GlobalKeyDown2}        from "@Common/ui-components/browser/global-key-down-2";
import {OnGlobalKeyDownEscape} from "@Common/ui-components/browser/global-key-down-escape";
import {toCssRect}             from "@Common/ui-components/image-editor/modes/crop-mode/dragging-rect-mode/to-css-rect";
import {isParentNode}          from "@Common/utils/browser/is-child-node";
import {last, reverse}         from "@Common/utils/collections";

import {avoidEdges}     from "../common/avoid-edges";
import {getWebstormUrl} from "../common/get-webstorm-url";
import {Path}           from "../common/path";
import {getTagPath}     from "../get-tag-path";

export const Rects = ({tags2, isHighlighted}) => cs(
    consumeContext("apis"),
    ({}, next) => (
        <div className="rects-1ei">
            {next()}
        </div>
    ),
    ["winSize", (_, next) => next({width: window.innerWidth, height: window.innerHeight})],
    ["hovered", (_, next) => UseState({next})],
    ["expandeds", (_, next) => UseState({next})],
    ({hovered, expandeds}, next) => fragments(
        next(),

        hovered.value && GlobalKeyDown2({
            check: keyCombo("E"),
            action: () => expandeds.change((_) => _?.includes(hovered.value) ? (
                _.filter((t) => t !== hovered.value)
            ) : (
                [
                    ..._??[],
                    hovered.value,
                ]
            )),
        }),
        expandeds.value?.length && (
            OnGlobalKeyDownEscape({
                action: () => expandeds.onChange(null),
            })
        ),
    ),
    ({apis, winSize, hovered, expandeds}) => reverse(tags2).map(({rect,tag, xdQa, hidden}, i) => cs(
        keyed(i),

        ["expanded", (_, next) => next(expandeds.value?.includes(tag))],
        ["code", ({expanded}, next) => Load({
            disabled: !expanded,
            fetch: () => apis.getCodeForTag(getTagPath(tag)),
            next,
        })],
        ({expanded, code}) => <>
            <div
                className={cx(
                    "rect",
                    {
                        hovered: hovered.value === tag,
                        expanded,
                        hidden: hidden || rect.width * rect.width === 0,
                        highlight: isHighlighted?.(xdQa),
                        parent: hovered.value && isParentNode(tag, hovered.value),
                    },
                )}
                style={toCssRect(rect)}
                onMouseEnter={() => hovered.onChange(tag)}
                onMouseLeave={() => hovered.onChange(null)}
                onClick={async (e) => {
                    if (e.metaKey && !e.shiftKey) {
                        e.stopPropagation();
                        const code = await apis.getCodeForTag(getTagPath(tag));
                        if (code) {
                            window.open(getWebstormUrl(last(code)))
                            // await apis.openFile(last(code));
                        }
                    }
                }}
            />


            {(hovered.value === tag || expanded) && (
                <div
                    className={cx("explain")}
                    style={{...toCssRect(rect)}}
                >
                    <div
                        className={cx(
                            "box",
                            avoidEdges(rect, winSize),
                            {touchable: expanded},
                        )}
                    >
                        <div className="xd">
                            <div className="text">
                                <div className="type">
                                    {xdQa.type}
                                </div>
                                {xdQa.name && (
                                    <div className="name">
                                        {" - "}
                                        {xdQa.name}
                                    </div>
                                )}
                            </div>
                        </div>

                        {code && expanded && (
                            <div className="code">
                                {reverse(code)?.map((code1, i) => cs(
                                    keyed(i),
                                    () => (
                                        <div
                                            className="line"
                                            onClick={(e) => {
                                                if (e.metaKey) {
                                                    window.open(getWebstormUrl(code1))
                                                }
                                            }}
                                        >
                                            {Path.basename(code1.file) + (code1.line ? ":" + code1.line : "")}
                                        </div>
                                    ),
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    )),
);
